/**
 * Токен для рукопожатия веб-сокета — из хранилища, а не из состояния `AuthContext`.
 *
 * Access-токен живёт 15 минут. REST обновляет его сам (`performTokenRefresh` в api/client.ts),
 * но кладёт новый только в хранилище: состояние `AuthContext` остаётся со старым. Сокет брал
 * токен из состояния и после первого же разрыва стучался с просроченным — сервер отказывал,
 * переподключение шло по кругу до перезапуска приложения. Сигналы звонка (invite, answer, bye)
 * при этом копились в очереди и не уходили: звонок с такого телефона до собеседника не доходил.
 *
 * Состояние намеренно не трогаем: от `accessToken` зависят эффекты сокета, пушей и языка, и
 * смена токена раз в 15 минут перезапускала бы их все — в том числе сокет посреди звонка.
 */
export async function resolveWsAccessToken(
  readStored: () => Promise<string | null>,
  fromState: string,
): Promise<string> {
  try {
    const stored = await readStored();
    return stored && stored.trim().length > 0 ? stored : fromState;
  } catch {
    return fromState;
  }
}
